var BaseViews = require('../../base');
var ProductZoomer = require('./product-zoomer');
var ProductZoomToggle = require('./product-zoom-toggle');
var UIUtils = require('../../../utils/ui');
var FarmBranding = require('../../farm-branding.js');

require('./product-zoomer-modal/product-zoomer-modal.scss');
var ProductZoomerModal = BaseViews.LayoutView.extend({
    className: 'fmcy-product-zoomer-modal',
    template: require('./product-zoomer-modal/product-zoomer-modal.html'),
    initialize: function(options) {
        var self = this;
        this.options = _.defaults(
            options || {},
            {
                theme: 'light'
            }
        );
    },
    ui: {
      btnClose: '.fmcy-menu-item-btn-close'
    },
    triggers: {
      'click @ui.btnClose': 'close:clicked'
    },
    regions: {
        productZoomerRegion: '.fmcy-item-zoomer-region',
        brandingRegion: '.fmcy-zoomer-branding-region'
    },
    _renderBranding: function () {
      var branding = new FarmBranding();
      this.brandingRegion.show(branding);
    },
    _renderZoomControls: function () {
      var
          self = this,
          zoomEnabled,
          imageSize
      ;

      if (UIUtils.isPhone()) {
          zoomEnabled = true;
          imageSize = 'large';
      } else {
          zoomEnabled = true;
          imageSize = 'xlarge';
      }

      var productZoomModel = new Backbone.Model({
          zoomEnabled: zoomEnabled,
          imageSize: imageSize
      });

      var productZoomer = new ProductZoomer({
          model: productZoomModel,
          theme: self.model.get('theme'),
          getImageBySize: function (size) {
              var imageURL = self.model.getProductImageURL(size);
              switch (size) {
                  case 'xlarge':
                      return {
                          url: imageURL,
                          w: 5000,
                          h: 3334
                      };
                  case 'large':
                      return {
                          url: imageURL,
                          w: 2500,
                          h: 1667
                      };
                  case 'medium':
                      return {
                          url: imageURL,
                          w: 1024,
                          h: 683
                      };
                  case 'thumb':
                      return {
                          url: imageURL,
                          w: 510,
                          h: 340
                      };
              }
          }
      });

      self.productZoomerRegion.show(productZoomer);
    },
    _onPopState: function (event) {
      this.trigger('close:clicked');
    },
    _onWindowKeyUp: function (event) {
      if (event.keyCode == 27) {
        this.trigger('close:clicked');
      }
    },
    onRender: function() {
      var self = this;
      this._renderZoomControls();
      this._renderBranding();
      $(window).on('keyup.' + this.cid, _.bind(this._onWindowKeyUp, this));
      $(window).on('popstate.' + this.cid, _.bind(this._onPopState, this));
      BaseViews.LayoutView.prototype.onRender.call(self);
    },
    onDestroy: function () {
      $(window).off('keyup.' + this.cid);
      $(window).off('popstate.' + this.cid);
      BaseViews.LayoutView.prototype.onDestroy.call(self);
    }
});

module.exports = ProductZoomerModal;



/** WEBPACK FOOTER **
 ** ./assets/js/common/menu/menu-item-expanded/product-zoomer-modal.js
 **/